module.exports = __webpack_public_path__ + "static/media/search.c41bb907.svg";